import React, { Component } from "react";
// import { Link } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  notification,
  Spin,
  message,
  Drawer,
} from "antd";

 import logo from "../assets/images/logo.png";

// import {
//   DribbbleOutlined,
//   TwitterOutlined,
//   InstagramOutlined,
//   GithubOutlined,
// } from "@ant-design/icons";

// import { Navigate } from "react-router-dom";

import ForgotPassword from "./../components/ForgotPassword";
import NewPassword from "./../components/NewPassword";

import {
  emailStripeLogin,
  nonUserStripeLogin,
  stripeLoginVerify,
  forgotPassword,
  superUserLogin,
  forgotPdPassword
} from "./../services";

function onChange(checked) {
  console.log(`switch to ${checked}`);
}
const { Title } = Typography;
const { Header, Content } = Layout;

export default class SignIn extends Component {
  constructor(props) {
    super(props);
    if (localStorage.getItem("is_auth")) {
      this.props.history.push("/dashboard");
    }
    this.state = {
      modalVisible: false,
      forgotData: {},
      loading: false,
      drawerVisible: false,
      authToken: "",
      otp: "",
      newPassword: false,
      passwordScreen:false,
      email:"",
      forgotpass:false
    };
  }

  handleButtonClick = () => {
    this.setState({ loading: true });
    // Make API call
    // Example: fetch('your_api_endpoint').then(response => { this.handleResponse(response); });
    // Once response comes, handleResponse(response);
  };

  handleResponse = (response) => {
    this.setState({ loading: false });
    if (response.ok) {
      this.setState({ drawerVisible: true });
    } else {
      message.error("Failed to connect. Please try again.");
    }
  };

  handleLogin  = async(values) =>{
      const userData = await superUserLogin(values);

      console.log(userData);

      if(userData.status==="success"){
        const {data} = userData;
        localStorage.setItem("is_auth", data["token"]);
        localStorage.setItem("auth_data", JSON.stringify(data));

        notification.success({
          message: userData.message,
        });
       

        window.location.reload();
      } else {
        
        notification.warning({
          message: "Incorrect Password",
        });
        
      }
  }
  handlePasswordLogin = async (values) => {

      const {email} = this.state;

      values.email = email;
      console.log(values);
      await this.handleLogin(values);
    
  }

  forgetHandle =  (trigger) => {

      if(trigger==="signin"){
         this.setState({ drawerVisible: false,passwordScreen:false,forgotpass:false });
      } else {

        this.setState({forgotpass:trigger});
      }
  }

  handleFormSubmit = async (values) => {
    this.setState({ loading: true });
    values.authToken = this.state.authToken;

    const thisData = await stripeLoginVerify(values);
    this.setState({ loading: false });

    if (thisData.status === "success") {
     
      this.setState({newPassword:true});


    } else {
      // message.warning("something went wrong.");

      notification.warning({
        message: thisData.message,
      });
    }

    console.log(thisData);

    // Make API call with OTP value
    // Example: fetch('your_api_endpoint', { method: 'POST', body: JSON.stringify({ otp }) })
    //   .then(response => { this.handleOtpResponse(response); });
    // Once response comes, handleOtpResponse(response);
  };

  handleOtpResponse = (response) => {
    if (response.ok) {
      message.success("Connected successfully!");
    } else {
      message.error("Failed to connect. Please try again.");
    }
    this.setState({ drawerVisible: false });
  };

  // componentDidMount(){

  //   if(localStorage.getItem('is_auth')){
  //     this.props.history.push('/user-list');
  //   }

  // }

  handleOpenModal = async () => {
    this.setState({ loading: true });
    const rdata = await forgotPassword();
    if (rdata) {
      if (rdata.status == "success") {
        message.success(rdata.message);
        localStorage.setItem("email_token", rdata.data.token);
        this.setState({ modalVisible: true, forgotData: rdata });
      } else {
        message.warning(rdata.message);
      }
    } else {
      this.setState({ modalVisible: true });
      message.warning("something went wrong.");
      this.setState({ loading: false });
    }
  };

  handleCloseModal = () => {
    this.setState({ modalVisible: false, loading: false });
  };


  loginFlow = async (values)=>{

    
       this.setState({ loading: true });
      const responseData = await emailStripeLogin(values);

      console.log(responseData);
      this.setState({ loading: false });
      if (responseData && responseData.status === "success") {
        this.setState({ drawerVisible: true });
        const { data } = responseData;

        this.setState({ authToken: data.token,passwordScreen:true,email : values.email });
        // message.success(responseData.message);

        // notification.success({
        //   message: responseData.message,
        // });

      } else {
        this.setState({ loading: true });
        const nonResponseData = await nonUserStripeLogin(values);
        this.setState({ loading: false });
        if (nonResponseData.status === "success") {
          this.setState({ drawerVisible: true });
          const { data } = nonResponseData;

          this.setState({ authToken: data.token ,email : values.email});
          message.success(nonResponseData.message);

        } else {
          notification.error({
            message: responseData.message,
            description: `Failed to connect. Please try again.`,
          });
        }
      }
  };

  onFinish = async (values) => {
     const { forgotpass } = this.state;
     
      if(forgotpass) {
           this.setState({ loading: true });
          const forgotUser = await forgotPdPassword(values);
          this.setState({ loading: false });
          if (forgotUser && forgotUser.status === "success") {
            this.setState({ drawerVisible: true });
            const { data } = forgotUser;

               this.setState({ authToken: data.token,email : values.email });
                message.success(forgotUser.message);
          }
        
          console.log("Forgot Flow:", values);   
      } else {
        console.log("Normal Flow:", values);   

          await this.loginFlow(values);
      }
      

      // 
     
  }

  render() {
    const { modalVisible, loading, forgotData, drawerVisible,newPassword,passwordScreen,forgotpass } = this.state;



      // const resp  =  await superUserLogin(values);
      // console.log(resp);

      // if(resp){
      //   // history.push("/user-list");

      //   // this.props.history.push('/user-list');
      //   // window.location.reload();
      // } else {

      //   notification.error({
      //       message: `Invalid Login Credentials`,
      //       description: `Invalid username or password`
      //     });
      // }
    // };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };


    return (
      <>
        <Layout className="stripe-login layout-default layout-signin ">
          <Header>
            <div className="header-col header-brand">
              <h5>Aletheia Run</h5>
            </div>
          </Header>
          <Content className="signin">
            <Row style={{ height: "100vh" }}>
              <Col flex="1 1 200px" className="login_side_a"></Col>
              <Col flex="0 1 600px" className="login_side_b">
                <div className="">
                  <div className="text-center">
                    <img
                      alt={logo}
                      src={logo}
                      style={{ height: "100px" }}
                    />
                    <Title className="mb-15">{forgotpass ? 'Forgot Password' : 'Sign In'} </Title>
                  </div>

                  <Title className="font-regular text-muted" level={5}>
                    Enter your email to connect with Aletheia Run.
                  </Title>
                  <Spin spinning={loading}>
                    <Form
                      onFinish={this.onFinish}
                      onFinishFailed={onFinishFailed}
                      layout="vertical"
                      className="row-col stripe-loginform"
                    >
                      <Form.Item
                        className="username"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please input your email!",
                          },
                        ]}
                      >
                        <Input placeholder="Email Address" />
                      </Form.Item>

                      {/* <Form.Item
                    className="username"
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input placeholder="Password" />
                  </Form.Item> */}

                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ width: "100%" }}
                        >
                         {forgotpass ? 'Submit' : 'Connect'} 
                        </Button>

                        <div className="forgot_password" >

                   {forgotpass ? <a  type="link" onClick={() => this.forgetHandle(false)} >Sign In </a>  : <a  type="link" onClick={() => this.forgetHandle(true)} >Forgot Password? </a>  } 

                  
                  </div>
                      </Form.Item>
                    </Form>
                  </Spin>
                  <div className="plansign_footer_links" >

                    By creating an account, you agree to Aletheia Run's <br/> 
                    <a target="_blank" href="https://www.aletheia.run/privacy-policy" type="link">Privacy Policy</a> and <a target="_blank" href="https://www.aletheia.run/terms-of-use" type="link">Terms of Use</a> 

                  
                  </div>
                </div>
              </Col>
              {/* <Col
                className="sign-img"
                style={{ padding: 12 }}
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
              >
                <img src={'http://34.221.95.211:8888/assets/img/pdlogin2.jpg'} alt="" />
              </Col> */}
            </Row>
          </Content>


          <Drawer
            // title="Enter OTP"
            placement="right"
            closable={false}
            className="otp_page"
            // onClose={() => this.setState({ drawerVisible: false })}
            visible={drawerVisible}
            // visible={true}
            // width={600}
          >

  {newPassword ? 
            <div className="password_section"> 
            <div className="text-center">
              <img
                alt={logo}
                  src={logo}
                style={{ height: "100px" }}
              />
              <Title className="mb-15">Set New Password</Title>
            </div>

            <NewPassword passwordLogin={this.handlePasswordLogin} authToken={this.state.authToken} />

           

            </div> : " " }


            {passwordScreen ? 
            <div className="password_section"> 
            <div className="text-center">
              <img
                alt={logo}
                  src={logo}
                style={{ height: "100px" }}
              />
              <Title className="mb-15">Enter Password</Title>
            </div>

            <Form onFinish={this.handlePasswordLogin} className="stripe-loginform">
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Enter password " }]}
              >
                <Input.Password
                  placeholder="Enter password"

                  onChange={(e) => this.setState({ password: e.target.value })}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Login
                </Button>
                <div className="forgot_password" >
                <a  type="link" onClick={() => this.forgetHandle('signin')} >Back to Login </a>
                </div>
              </Form.Item>
            </Form>

           

            </div> : " " }

{ !newPassword && !passwordScreen ?

         <div className="otp_section"> 

            <div className="text-center">
              <img
                alt={logo}
                  src={logo}
                style={{ height: "100px" }}
              />
              <Title className="mb-15">Email Verification</Title>
            </div>

            <Form onFinish={this.handleFormSubmit} className="stripe-loginform">
              <Form.Item
                name="otp"
                rules={[{ required: true, message: "Enter Verification Code" }]}
              >
                <Input
                  placeholder="Enter Verification Code"
                  onChange={(e) => this.setState({ otp: e.target.value })}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Connect
                </Button>
                <div className="forgot_password" >
                <a  type="link" onClick={() => this.forgetHandle('signin')} >Back to Login </a>
                </div>
              </Form.Item>
            </Form>

            <div className="otp_footer_links" >

            A verification code has been sent to your email.   <br/> <br/> 
            Please check your spam or junk folders if you  <br/> 
            do not see it.

                  
                  </div>
                  </div> : "" }

                
          </Drawer>

          {/* <ForgotPassword visible={modalVisible} rData={forgotData} onClose={this.handleCloseModal} /> */}
        </Layout>
      </>
    );
  }
}
